export default "/images/ETL.jpg?2e34fd3046e7ab685d2149013044c6ee";